<template>
  <div class="control" v-if="SeoIsActive">
    <div class="control__title">
      <div class="title">
        <div class="title-text">
          {{ title }}
        </div>
        <div class="control__helper">
          <div
            class="control__trigger"
            @mouseover="showHint = true"
            @mouseleave="showHint = false"
          >
            <img
              src="https://sirv.sirv.com/website/theme2/icon/question.svg"
              :alt="hint"
            >
          </div>
          <div
            v-show="showHint"
            class="hint"
            v-html="hint"
            @mouseover="showHint = true"
            @mouseleave="showHint = false"
          >
          </div>
        </div>
      </div>
    </div>
    <div class="control__action">
      <div class="control__choice">
        <div
          class="fakeoverlay"
          :class="{disabled: !selectStatus}"
          @click="selectStatus =! selectStatus"
        />
        <el-input
          v-model="value"
          :disabled="!selectStatus"
          @change="changeOption"
        />
      </div>
      <el-checkbox
        v-model="selectStatus"
        class="control__checkbox"
        @change="changeOption"
      />
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  name: 'SeoTextInput',
  props: {
    title: {
      type: String,
      default: ''
    },
    default: {
      type: String,
      default: ''
    },
    hint: {
      type: String,
      default: ''
    },
    status: {
      type: Boolean
    },
    parameter: {
      type: String,
      default: ''
    },
    eventClick: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      value: this.default,
      selectStatus: this.status,
      showHint: false
    }
  },
  computed: {
    ...mapState(['clearOptions', 'settings']),
    SeoIsActive(){
      let { options } = this.settings
      return options.includes('video.seo:true;')
    }
  },
  watch: {
    clearOptions (val) {
      if (val) {
        this.selectStatus = false
      }
    },
    eventClick (val) {
      this.selectStatus = val
      this.value = this.default
    },
    selectStatus (val) {
      if (val) {
        this.changeOption()
      }
    },
    SeoIsActive(val){
      if( val === false ){
        this.selectStatus = false
        this.value = this.default
        this.$emit('changeOption', {
          parameter: `${this.parameter}`,
          separator: ':',
          value: ''
        })
      }
    }
  },

  methods: {
    changeOption () {
      const value = this.selectStatus === true ? `${this.value}` : ''
      this.$emit('changeOption', {
        parameter: `${this.parameter}`,
        separator: ':',
        value: value
      })
    }
  }
}
</script>
